import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Table,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
  List,
  DatePicker,
  Tag,
  Progress,
  Alert,
} from "antd";
import {
  EditOutlined,
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
  FileProtectOutlined,
  UnorderedListOutlined,
  FileSyncOutlined,
  CheckCircleOutlined,
  FileDoneOutlined,
  ApartmentOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../../services/http";
import dayjs from "dayjs";
const { Text } = Typography;

// STATUS
const options_status = [
  { value: 0, label: "Inativo" },
  { value: 1, label: "Ativo" },
];

export const CadAvaliacoes = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();
  const [messageApi, contextMessage] = message.useMessage();

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);
  const [search, setSearch] = useState("");

  useEffect(() => {
    listarAvaliacoes();
  }, []);

  // LISTAR
  const listarAvaliacoes = async () => {
    setLoading(true);
    const api = await http("get", `v1/avaliacoes/listar`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarAvaliacao = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/avaliacoes/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarAvaliacoes();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarAvaliacao = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/avaliacoes/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      listarAvaliacoes();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarAvaliacao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/avaliacoes/carregar/${id}`, []);
    if (api.statusCode === 200) {
      if (api?.response?.data) {
        setShowModal(true);
        resetForm();
        form.setFieldsValue({
          descricao: api?.response?.data?.descricao,
          ano: dayjs().year(api?.response?.data?.ano),
          status: api?.response?.data?.status,
        });
        setIdAlt(api.response.data.id);
      }
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // GERAR FORMULÁRIO
  const gerarFormulario = async (id) => {
    if (!id) return;
    setLoading(true);
    messageApi.open({
      key: "gerar_formulario",
      type: "loading",
      content: "Gerando formulários...",
      duration: 0,
    });

    const api = await http("post", `v1/avaliacoes/gerar_formularios`, { id: id }, "application/json");
    if (api.statusCode === 200) {
      messageApi.open({
        key: "gerar_formulario",
        type: "success",
        content: "Formulários Gerados!",
        duration: 2,
      });
      listarAvaliacoes();
    } else {
      listarAvaliacoes();
      messageApi.open({
        key: "gerar_formulario",
        type: "error",
        content: api?.response?.message,
        duration: 2,
      });
    }
    setLoading(false);
  };

  // LIBERAR RESULTADOS
  const liberarResultados = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("post", `v1/avaliacoes/liberar_resultados`, { id: id });
    if (api.statusCode === 200) {
      message.success("Resultados liberados com sucesso!");
      listarAvaliacoes();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarAvaliacao = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/avaliacoes/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarAvaliacoes();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // COLUNAS TABLE
  const columns = [
    {
      dataIndex: "descricao",
      title: "Descrição",
      sorter: (a, b) => a.descricao?.localeCompare(b.descricao),
    },
    {
      dataIndex: "ano",
      title: "Ano",
      sorter: (a, b) => a.ano?.toString()?.localeCompare(b.ano?.toString()),
    },
    {
      key: "status",
      title: "Status",
      render: (_, e) => (e.status === 1 ? "Ativo" : "Inativo"),
      sorter: (a, b) => (a.status === 1 ? "Ativo" : "Inativo")?.localeCompare(b.status === 1 ? "Ativo" : "Inativo"),
    },
    {
      key: "status_formulario",
      title: "Formulário",
      render: (_, e) => (e.status_formulario === 1 ? "Gerado" : "Aguardando"),
      sorter: (a, b) =>
        (a.status_formulario === 1 ? "Gerado" : "Aguardando")?.localeCompare(
          b.status_formulario === 1 ? "Gerado" : "Aguardando"
        ),
    },
    {
      key: "status_liberacao_resultado",
      title: "Resultados",
      render: (_, e) => (e.status_liberacao_resultado === 1 ? "Liberado" : "Não Liberado"),
      sorter: (a, b) =>
        (a.status_liberacao_resultado === 1 ? "Liberado" : "Não Liberado")?.localeCompare(
          b.status_liberacao_resultado === 1 ? "Liberado" : "Não Liberado"
        ),
    },
    {
      title: "Setores",
      key: "total_setores",
      width: 50,
      render: (_, e) =>
        e.total_setores > 0 ? <Tag color="green">{e.total_setores}</Tag> : <Tag color="red">{e.total_setores}</Tag>,
      sorter: (a, b) => a.total_setores?.toString()?.localeCompare(b.total_setores?.toString()),
    },
    {
      key: "acoes",
      title: "Ações",
      width: 150,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Formulários">
            <Button
              loading={loading}
              onClick={() => navigate(`/avaliacoes/gestao/formularios/${e.id}`)}
              icon={<UnorderedListOutlined />}
            />
          </Tooltip>

          <Tooltip title="Filiais/Setores">
            <Button
              loading={loading}
              onClick={() => navigate(`/avaliacoes/gestao/setores/${e.id}`)}
              icon={<ApartmentOutlined />}
            />
          </Tooltip>

          <Tooltip title="Editar">
            <Button loading={loading} onClick={() => carregarAvaliacao(e.id)} icon={<EditOutlined />} />
          </Tooltip>

          {e.status_formulario === 0 && (
            <React.Fragment>
              <Tooltip title="Excluir">
                <Button
                  loading={loading}
                  icon={<DeleteOutlined />}
                  onClick={() => {
                    modal.confirm({
                      title: "Deseja deletar este registro?",
                      okText: "Sim",
                      cancelText: "Cancelar",
                      onOk() {
                        deletarAvaliacao(e.id);
                      },
                    });
                  }}
                />
              </Tooltip>
              <Tooltip title="Gerar Formulário">
                <Button
                  loading={loading}
                  onClick={() => {
                    modal.confirm({
                      title: "Deseja gerar os formulários?",
                      content: (
                        <Alert
                          message="Antes de prosseguir, verifique se todos os cargos possuem avaliadores!"
                          type="info"
                          showIcon
                        />
                      ),
                      okText: "Sim",
                      cancelText: "Cancelar",
                      onOk() {
                        gerarFormulario(e.id);
                      },
                    });
                  }}
                  icon={<FileSyncOutlined />}
                />
              </Tooltip>
            </React.Fragment>
          )}
          {e.status_formulario === 1 && e.status_liberacao_resultado === 0 && (
            <Tooltip title="Liberar Resultados">
              <Button
                loading={loading}
                onClick={() => {
                  modal.confirm({
                    title: "Deseja liberar os resultados?",
                    content: (
                      <Alert
                        message="Somente serão liberados para visualização as avaliações finalizadas!"
                        type="info"
                        showIcon
                      />
                    ),
                    okText: "Sim",
                    cancelText: "Cancelar",
                    onOk() {
                      liberarResultados(e.id);
                    },
                  });
                }}
                icon={<FileDoneOutlined />}
              />
            </Tooltip>
          )}
        </Space.Compact>
      ),
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    formulario.ano = dayjs(formulario.ano).format("YYYY");

    if (idAlt > 0) {
      formulario.id = idAlt;
      alterarAvaliacao(formulario);
    } else {
      cadastrarAvaliacao(formulario);
    }
  };

  // FORMULÁRIO
  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Avaliação
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="descricao"
                label="Descrição"
                rules={[{ required: true, message: "Digite a descrição!" }]}>
                <Input size="large" disabled={loading} placeholder="Informe a descrição" />
              </Form.Item>
            </Col>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="ano" label="Ano" rules={[{ required: true, message: "Digite o ano!" }]}>
                <DatePicker placeholder="Selecione o ano" style={{ width: "100%" }} size="large" picker="year" />
              </Form.Item>
            </Col>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="status" label="Status" rules={[{ required: true, message: "Selecione o status!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione o status"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_status}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter(
      (val) =>
        val.descricao?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.ano?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        dayjs(val.data_liberacao_resultado)?.format("DD/MM/YYYY")?.toLowerCase().includes(pesquisar.toLowerCase())
    );
    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Avaliações" onClickBack={() => navigate("/")} />
            <HeaderTitle
              loading={loading}
              title="Avaliações Gestão"
              subtitle="Cadastro de avaliações"
              icon={<FileProtectOutlined />}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                <Tooltip title="Adicionar Registro">
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setShowModal(true);
                      resetForm();
                    }}
                    loading={loading}>
                    Novo
                  </Button>
                </Tooltip>
              </Space>

              <Divider />

              <Table
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
                rowKey="id"
                expandable={{
                  expandedRowRender: (e) => (
                    <List
                      size="small"
                      dataSource={e.formularios}
                      renderItem={(item) => (
                        <List.Item>
                          <Space>
                            <Tooltip title="Editar Cargos">
                              <Button
                                size="small"
                                loading={loading}
                                onClick={() => navigate(`/avaliacoes/gestao/formularios/${e?.id}/cargos/${item.id}`)}
                                icon={<CheckCircleOutlined />}
                              />
                            </Tooltip>
                            <Text>
                              {item.classificacao} - {item.formulario}
                            </Text>
                          </Space>
                          <Progress
                            size="small"
                            percent={(item.total_formularios > 0
                              ? (item.total_realizados * 100) / item.total_formularios
                              : 0
                            ).toFixed(2)}
                            steps={10}
                            strokeColor={"#60b565"}
                          />
                        </List.Item>
                      )}
                    />
                  ),
                }}
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
      {contextMessage}
    </Row>
  );
};
